import { Controller } from "@hotwired/stimulus"

// Active le bouton "marquer comme vu" lorsque la vidéo est terminée.
// Si pas de vidéo (chapitre texte seul) ou contenu déjà vu, le bouton
// reste actif d'emblée. Aucun verrouillage de sécurité ici : la garde
// réelle est serveur (Student::ChapterPolicy).
export default class extends Controller {
  static targets = ["video", "markButton"]
  static values = { viewed: Boolean }

  connect() {
    if (this.viewedValue || !this.hasVideoTarget) {
      this.enableMarkButton()
    } else {
      this.disableMarkButton()
    }
  }

  markWatched() {
    this.enableMarkButton()
  }

  enableMarkButton() {
    if (this.hasMarkButtonTarget) {
      this.markButtonTarget.disabled = false
    }
  }

  disableMarkButton() {
    if (this.hasMarkButtonTarget) {
      this.markButtonTarget.disabled = true
    }
  }
}
